import React from 'react'
import { useDispatch } from 'react-redux'

import { SnackbarProvider } from 'notistack'

import { CssBaseline, ThemeProvider, Theme, StyledEngineProvider } from '@mui/material'

import { ThemeProvider as ThemeProviderLegacy } from '@mui/styles'

import * as settingsActions from '../../store/settings/settings.actions'

import SnackbarComponent from '../../shared/components/MessageComponents/SnackbarComponent'
import { Customer } from '../../shared/types/commonTypes'

import Env from '../../config/envConfig'
import getAppTheme from '../../config/getAppTheme'

import SelectModule from './SelectModule'

const App: React.FC = () => {
  const dispatch = useDispatch()

  const language = 'de'
  const customer = Customer.default

  const basePath = Env.restBase
  window.localStorage.setItem('basePath', basePath)

  const theme: Theme = getAppTheme(language, customer)
  dispatch(settingsActions.setTheme(theme))

  return (
    <ThemeProvider theme={theme}>
      <ThemeProviderLegacy theme={theme}>
        <StyledEngineProvider injectFirst>
          <SnackbarProvider maxSnack={5}>
            <CssBaseline />
            <SelectModule customer={customer} />
            <SnackbarComponent />
          </SnackbarProvider>
        </StyledEngineProvider>
      </ThemeProviderLegacy>
    </ThemeProvider>
  )
}

export default App
